import React from "react";

import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import nextjs from "../assets/nextjs.png";
import robot from "../assets/robot.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import kubernetes from "../assets/kube2.png";
import selenium from "../assets/Selenium4.png";
import testrail from "../assets/TestRail.svg";
import gcp from "../assets/GCP1.png";
import aws from "../assets/aws.png";
import docker from "../assets/docker2.webp";

const Experience = () => {
  const techs = [
    {
      id: 1,
      src: selenium,
      title: "Selenium",
      style: "shadow-green-500",
    },
    {
      id: 2,
      src: robot,
      title: "RobotFramework",
      style: "shadow-[#00c0b5]",
    },
    {
      id: 3,
      src: testrail,
      title: "Test Rail",
      style: "shadow-[#0E3754]",
    },
    {
      id: 4,
      src: gcp,
      title: "GCP",
      style: "shadow-[#FFFFFF]",
    },
    {
      id: 5,
      src: aws,
      title: "AWS",
      style: "shadow-[#ec7211]",
    },
    {
      id: 6,
      src: docker,
      title: "Docker",
      style: "shadow-[#0b214a]",
    },
    {
      id: 7,
      src: kubernetes,
      title: "Kubernetes",
      style: "shadow-[#3371e3]",
    },
    {
      id: 8,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400",
    },
    {
      id: 9,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 10,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 11,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 12,
      src: reactImage,
      title: "React",
      style: "shadow-[#61dafb]",
    },
    {
      id: 13,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 14,
      src: nextjs,
      title: "Next JS",
      style: "shadow-white",
    },
  ];

  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-screen"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Experience
          </p>
          <p className="py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
